var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 125 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Clear Filter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m83,24l43,0a2,2 0 0 0 0,-4l-43.53,0a15.92,15.92 0 0 1 0.53,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m2,24l49,0a15.92,15.92 0 0 1 0.53,-4l-49.53,0a2,2 0 0 0 0,4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m2,80a2,2 0 0 0 0,4l10.14,0a14.47,14.47 0 0 1 0,-4l-10.14,0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m44,82a16.01,16.01 0 0 1 -0.14,2l33.31,0a27.8,27.8 0 0 1 1.54,-4l-34.85,0a16.01,16.01 0 0 1 0.14,2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m126,50l-4.14,0a14.47,14.47 0 0 1 0,4l4.14,0a2,2 0 0 0 0,-4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m2,54l88.14,0a14.47,14.47 0 0 1 0,-4l-88.14,0a2,2 0 0 0 0,4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m94,52a12,12 0 1 0 12,-12a12.01,12.01 0 0 0 -12,12zm20,0a8,8 0 1 1 -8,-8a8.01,8.01 0 0 1 8,8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m28,70a12,12 0 1 0 12,12a12.01,12.01 0 0 0 -12,-12zm0,20a8,8 0 1 1 8,-8a8.01,8.01 0 0 1 -8,8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m55,24a12,12 0 1 0 12,-12a12.01,12.01 0 0 0 -12,12zm20,0a8,8 0 1 1 -8,-8a8.01,8.01 0 0 1 8,8z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m104,68a24,24 0 1 0 24,24a24.03,24.03 0 0 0 -24,-24zm0,44a20,20 0 1 1 20,-20a20.02,20.02 0 0 1 -20,20z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m113.52,82.48a2,2 0 0 0 -2.83,0l-6.69,6.69l-6.69,-6.69a2,2 0 0 0 -2.83,2.83l6.69,6.69l-6.69,6.69a2,2 0 1 0 2.83,2.83l6.69,-6.69l6.69,6.69a2,2 0 0 0 2.83,-2.83l-6.69,-6.69l6.69,-6.69a2,2 0 0 0 0,-2.83z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFilter);
export default __webpack_public_path__ + "static/media/clear-filter.4a0c016768a15100baa3b72e15a607d2.svg";
export { ForwardRef as ReactComponent };